import { BrgButton, ButtonVariant, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ErrorText, ErrorTitle, PaymentErrorOuterWrapper } from './styles'
import { bColor } from "../../../core/utils/bColor";
import { useTheme } from "styled-components";
import styled from 'styled-components';
import { CreateLinkTo } from 'shared/constants/linkTo';

const DRUGOYE_DELO_COMPETITION_IDS = new Set([
    '3ed8dd343f454c0a9052a92e57cac8f1',
    'a049d4b8f2094fbb85b29ec11fa2f30d',
]);

const InlineLink = styled.a`
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        opacity: 0.75;
        color: inherit;
    }
`;

interface CompetitionProjectSentProps {
    onClick?: () => void
    onClose?: () => void
    competitionId?: string
    projectId?: string
}

const CompetitionProjectSent: FC<CompetitionProjectSentProps> = ({ onClick, competitionId, projectId }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const isMobile = useIsMobile()
    const isDarkTheme = bColor.isDark(theme.app.backgroundColor)

    const isDrugoyeDelo = !!competitionId && DRUGOYE_DELO_COMPETITION_IDS.has(competitionId);

    if (isDrugoyeDelo) {
        const projectHref = projectId ? CreateLinkTo.project(projectId) : undefined;
        const competitionHref = competitionId ? CreateLinkTo.competition(competitionId) : undefined;

        return <PaymentErrorOuterWrapper>
            <ErrorTitle mobile={isMobile} isDarkTheme={isDarkTheme}>
                <Trans i18nKey="project_edit.drugoye_delo_sent">
                    <InlineLink href={projectHref} />
                    <InlineLink href={competitionHref} />
                </Trans>
            </ErrorTitle>
            <ErrorText mobile={isMobile} isDarkTheme={isDarkTheme}>
                <Trans i18nKey="project_edit.drugoye_delo_details">
                    <InlineLink href="https://vk.cc/cX5bcO" target="_blank" rel="noopener noreferrer" />
                </Trans>
            </ErrorText>
            <BrgButton variant={ButtonVariant.Filled} onClick={onClick}>
                {t("project_edit.go_to_competition")}
            </BrgButton>
        </PaymentErrorOuterWrapper>
    }

    return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile} isDarkTheme={isDarkTheme}>{t("project_edit.project_sent_to_competition")}</ErrorTitle>
        <ErrorText mobile={isMobile} isDarkTheme={isDarkTheme}>{t("project_edit.project_sent_to_competition_description")}</ErrorText>
        <BrgButton variant={ButtonVariant.Filled} onClick={onClick}>
            {t("project_edit.go_to_competition")}
        </BrgButton>
    </PaymentErrorOuterWrapper>
}

export default CompetitionProjectSent;
import { BrgButton, ButtonVariant, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ErrorText, ErrorTitle, PaymentErrorOuterWrapper } from './styles'
import { bColor } from "../../../core/utils/bColor";
import { useTheme } from "styled-components";
import styled from 'styled-components';
import { CreateLinkTo } from 'shared/constants/linkTo';

const DRUGOYE_DELO_COMPETITION_IDS = new Set([
    '3ed8dd343f454c0a9052a92e57cac8f1',
    'a049d4b8f2094fbb85b29ec11fa2f30d',
]);

const InlineLink = styled.a`
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        opacity: 0.75;
        color: inherit;
    }
`;

interface CompetitionProjectSentProps {
    onClick?: () => void
    onClose?: () => void
    competitionId?: string
    projectId?: string
}

const CompetitionProjectSent: FC<CompetitionProjectSentProps> = ({ onClick, competitionId, projectId }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const isMobile = useIsMobile()
    const isDarkTheme = bColor.isDark(theme.app.backgroundColor)

    const isDrugoyeDelo = !!competitionId && DRUGOYE_DELO_COMPETITION_IDS.has(competitionId);

    if (isDrugoyeDelo) {
        const projectHref = projectId ? CreateLinkTo.project(projectId) : undefined;
        const competitionHref = competitionId ? CreateLinkTo.competition(competitionId) : undefined;

        return <PaymentErrorOuterWrapper>
            <ErrorTitle mobile={isMobile} isDarkTheme={isDarkTheme}>
                <Trans i18nKey="project_edit.drugoye_delo_sent">
                    <InlineLink href={projectHref} />
                    <InlineLink href={competitionHref} />
                </Trans>
            </ErrorTitle>
            <ErrorText mobile={isMobile} isDarkTheme={isDarkTheme}>
                <Trans i18nKey="project_edit.drugoye_delo_details">
                    <InlineLink href="https://vk.cc/cX5bcO" target="_blank" rel="noopener noreferrer" />
                </Trans>
            </ErrorText>
            <BrgButton variant={ButtonVariant.Filled} onClick={onClick}>
                {t("project_edit.go_to_competition")}
            </BrgButton>
        </PaymentErrorOuterWrapper>
    }

    return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile} isDarkTheme={isDarkTheme}>{t("project_edit.project_sent_to_competition")}</ErrorTitle>
        <ErrorText mobile={isMobile} isDarkTheme={isDarkTheme}>{t("project_edit.project_sent_to_competition_description")}</ErrorText>
        <BrgButton variant={ButtonVariant.Filled} onClick={onClick}>
            {t("project_edit.go_to_competition")}
        </BrgButton>
    </PaymentErrorOuterWrapper>
}

export default CompetitionProjectSent;
